<template>
    <div>
        <el-form ref="form" :model="form" label-width="100px" :rules="$rules.AddMenu">
            <el-row >
                <el-col >
                     <el-form-item label="菜单名称：" prop="name">
                        <el-input  v-model="form.name" placeholder="请输入菜单名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col  >
                     <el-form-item label="菜单路径："  prop="link">
                        <el-input  v-model="form.link" placeholder="请输入菜单路径"></el-input>
                    </el-form-item>
                </el-col>
                <el-col  >
                  <el-form-item label="导航是否展示："   label-width="126px" >
                     <el-switch
                        v-model="form.show"
                        active-color="#13ce66"
                        inactive-color="#ff4949">
                      </el-switch>
                    </el-form-item>
                </el-col>
                <el-col  >
                     <el-form-item label="排序值："  >
                        <el-input-number  v-model.number="form.sortValue" ></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col  >
                     <el-form-item label="菜单描述："  prop="description">
                        <el-input  type="textarea" :autosize="{ minRows: 3}"  v-model="form.description" placeholder="请输入菜单描述"></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="11" v-if="type == 'add'">
                     <el-form-item label="菜单图标：" prop="pdk">
                    </el-form-item>
                </el-col> -->
            </el-row>
            <el-row>
                <el-col class="buttons">
                    <el-button @click="$emit('update:visibles',false)">取消</el-button>
                    <el-button type="primary" @click="submit()">提交</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
export default {
  components: {

  },
  props: {
    type: {
      type: String
    },
    row: {
      type: Object
    }
  },
  data () {
    return {
      form: {
        sortValue: 1,
        show: true
      },
      loading: false,
      departmentList: [],
      deptIds: null
    }
  },
  methods: {
    // 新增
    add_data () {
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1

      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 列表按钮
    event_button (row, type) {
    },
    // 提交
    submit () {
      var that = this
      that.$refs.form.validate((valid) => {
        if (valid) {
          // eslint-disable-next-line no-unused-vars
          var Submitform = {}
          if (that.type === 'add') {
            Submitform = this.form
            Submitform.parentId = 0
          } else if (this.type === 'edit') {
            Submitform = {
              id: that.form.id,
              name: that.form.name,
              link: that.form.link,
              sortValue: Number(that.form.sortValue),
              description: that.form.description,
              parentId: that.row.parentId,
              show: that.form.show
            }
          } else if (this.type === 'AddMenu') {
            Submitform = {
              parentId: that.row.id,
              name: that.form.name,
              link: that.form.link,
              sortValue: that.form.sortValue,
              description: that.form.description,
              show: that.form.show
            }
          }
          var RequestType = that.type === 'add' || that.type === 'AddMenu' ? 'post' : 'post'
          var RequestTypeText = that.type === 'add' || that.type === 'AddMenu' ? '添加' : '修改'
          var RequestUrl = that.type === 'add' || that.type === 'AddMenu' ? '"/ucenter/menu/save"' : '"/ucenter/menu/save"'
          // eslint-disable-next-line
          eval(
                `that.$http.${RequestType}(${RequestUrl},${JSON.stringify(Submitform)}).then((res) => {
                    if(res.status == 200){
                        that.$message.success('${RequestTypeText}成功')
                        that.$emit('update:visibles',false)
                        that.$emit('Render')
                        sessionStorage.removeItem('dict.department.list')
                    } else {
                        that.$message.error('${RequestTypeText}失败')
                        that.$emit('update:visibles',true)
                    }
                })`
          )
        }
      })
    },
    // js暂停的方法
    sleep (interval) {
      return new Promise(resolve => {
        this.loading = true
        setTimeout(resolve, interval)
      })
    },
    async Layoutfun (query = '', data, Parameter1) {
      if (query !== '') {
        await this.sleep(150)
        this.loading = false
        // eslint-disable-next-line no-eval
        return data.filter(item => { return eval('item.' + Parameter1).toLowerCase().indexOf(query.toLowerCase()) > -1 })
      } else {
        return data.slice(0, 10)
      }
    },
    // 所属部门
    departmentRemoteMethod (query) {
      this.Layoutfun(query, this.$department.list(), 'name').then(res => {
        this.departmentList = res
        this.addValueOptions()
      })
    },
    // 修改回显问题
    addValueOptions () {
      if (this.deptIds) {
        const target = this.$department.list().find((item) => { // 从大option中找到当前条
          return item.id === this.deptIds
        })
        if (target) { // 将当前条与小option比对，没有则加入
          if (this.departmentList.every(item => item.id !== target.id)) {
            this.departmentList.unshift(target)
          }
        }
      }
    }
  },
  created () {
    if (this.type === 'edit') {
      this.form = JSON.parse(JSON.stringify(this.row))
      this.deptIds = this.form.deptId
    }
    this.departmentRemoteMethod()
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
.buttons{
    text-align: center;
}
</style>
